import { Injectable } from '@angular/core';
import { HttpService } from './HttpService';
import { Observable } from 'rxjs';
import { IEmployee } from '../models/IEmployee';
import { IEvent } from '../models/IEvent';

@Injectable()
export class EventsService {
    constructor(private http: HttpService) { }

    getUpcomingEvents(): Observable<IEvent[]> {
        return this.http.get<IEvent[]>(`events`);
    }


}
